import { apiUrl } from '@/config/api';
import { getAuthToken } from '@/utils/auth';

function headers() {
  const next = { 'Content-Type': 'application/json' };
  const token = getAuthToken();
  if (token) next.Authorization = `Bearer ${token}`;
  return next;
}

async function postJson(path, body) {
  const response = await fetch(apiUrl(path), {
    method: 'POST',
    credentials: 'include',
    headers: headers(),
    body: JSON.stringify(body || {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail?.message || data.detail || data.message || 'Voice request failed');
    error.status = response.status;
    error.payload = data;
    throw error;
  }
  return data;
}

export async function startVoiceSession(language = 'en') {
  return postJson('/api/voice/session', { language });
}

export async function sendVoiceTurn({
  sessionId,
  text,
  audioBase64,
  mime = 'audio/webm',
  includeAudio = true,
  language = 'en',
}) {
  return postJson('/api/voice/turn', {
    session_id: sessionId,
    text: text || null,
    audio_base64: audioBase64 || null,
    mime,
    include_audio: includeAudio,
    language,
  });
}

export async function transcribeVoiceNote({ audioBase64, mime = 'audio/webm' }) {
  return postJson('/api/voice/transcribe', {
    audio_base64: audioBase64,
    mime,
  });
}
